"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlexUserRelationState = void 0;
var PlexUserRelationState;
(function (PlexUserRelationState) {
    PlexUserRelationState["Owner"] = "OWNER";
    PlexUserRelationState["Manager"] = "MANAGER";
    PlexUserRelationState["Member"] = "MEMBER";
    PlexUserRelationState["Subscriber"] = "SUBSCRIBER";
    PlexUserRelationState["SameDomainUser"] = "SAME_DOMAIN_USER";
    PlexUserRelationState["NoRelation"] = "NO_RELATION";
})(PlexUserRelationState = exports.PlexUserRelationState || (exports.PlexUserRelationState = {}));
//# sourceMappingURL=PlexUserRelationState.js.map